const PenEdit = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5043 4.99327L15.8835 6.61403C15.7183 6.77927 15.4511 6.77927 15.2858 6.61403L11.3833 2.71153C11.218 2.54629 11.218 2.27909 11.3833 2.11385L13.0041 0.493086C13.6615 -0.164362 14.7303 -0.164362 15.3913 0.493086L17.5043 2.60606C18.1652 3.26351 18.1652 4.3323 17.5043 4.99327ZM9.99104 3.5061L0.758577 12.7385L0.0132301 17.0101C-0.0887278 17.5867 0.41403 18.086 0.990619 17.9875L5.2623 17.2387L14.4948 8.00628C14.66 7.84103 14.66 7.57384 14.4948 7.4086L10.5922 3.5061C10.4235 3.34086 10.1563 3.34086 9.99104 3.5061ZM4.36226 11.9474C4.16889 11.7541 4.16889 11.4447 4.36226 11.2513L9.77657 5.83705C9.96994 5.64368 10.2793 5.64368 10.4727 5.83705C10.6661 6.03042 10.6661 6.3398 10.4727 6.53317L5.05839 11.9474C4.86502 12.1408 4.55563 12.1408 4.36226 11.9474ZM3.09306 14.9042H4.78064V16.1804L2.51296 16.5777L1.41955 15.4843L1.81683 13.2166H3.09306V14.9042Z"
      fill="white"
    />
  </svg>
);
export default PenEdit